var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-block offcanvas-close",
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            },
            [
              _c("span", [
                _vm._v(
                  "\n                    Menü schließen\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "icon icon-x",
                  attrs: { width: "32", height: "32", fill: "currentColor" },
                },
                [_c("use", { attrs: { "xlink:href": "#x" } })]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _c("li", { staticClass: "mobile-navigation__item" }, [
                _vm.dataContainer1.parent
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "mobile-navigation__link mobile-navigation--back",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer1.parent &&
                                _vm.dataContainer1.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon icon-chevron-left",
                            attrs: {
                              width: "32",
                              height: "32",
                              fill: "currentColor",
                            },
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#chevron-left" },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        Zurück\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.dataContainer1.parent && _vm.dataContainer1.parent.details
                ? _c("li", { staticClass: "mobile-navigation__item" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "mobile-navigation__link mobile-navigation--current",
                        attrs: {
                          href: _vm.getCategoryUrl(
                            _vm.dataContainer1.parent.url
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.dataContainer1.parent.details[0].name) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function (category) {
                return _c(
                  "li",
                  { staticClass: "mobile-navigation__item" },
                  [
                    category.childCount
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "mobile-navigation__link",
                              on: {
                                click: function ($event) {
                                  return _vm.slideTo(category)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(category.details[0].name) +
                                  "\n                            "
                              ),
                              _c(
                                "svg",
                                {
                                  staticClass: "icon icon-chevron-right",
                                  attrs: {
                                    width: "32",
                                    height: "32",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#chevron-right" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "mobile-navigation__link",
                              attrs: { href: _vm.getCategoryUrl(category.url) },
                            },
                            [_vm._v(_vm._s(category.details[0].name))]
                          ),
                        ],
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function (number) {
                      return _c(
                        "li",
                        { staticClass: "mobile-navigation__item" },
                        [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ]
                      )
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(
                    _vm.dataContainer1.parent.childCount,
                    function (number) {
                      return _c(
                        "li",
                        { staticClass: "mobile-navigation__item" },
                        [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ]
                      )
                    }
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._m(0),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu",
              attrs: { id: "menu-2" },
            },
            [
              _c("li", { staticClass: "mobile-navigation__item" }, [
                _vm.dataContainer2.parent
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "mobile-navigation__link mobile-navigation--back",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              (_vm.dataContainer2.parent &&
                                _vm.dataContainer2.parent.parent) ||
                                null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon icon-chevron-left",
                            attrs: {
                              width: "32",
                              height: "32",
                              fill: "currentColor",
                            },
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#chevron-left" },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n                        Zurück\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.dataContainer2.parent && _vm.dataContainer2.parent.details
                ? _c("li", { staticClass: "mobile-navigation__item" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "mobile-navigation__link mobile-navigation--current",
                        attrs: {
                          href: _vm.getCategoryUrl(
                            _vm.dataContainer2.parent.url
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.selectedCategory.details[0].name) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c(
                  "li",
                  { staticClass: "mobile-navigation__item" },
                  [
                    category.childCount
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "mobile-navigation__link",
                              on: {
                                click: function ($event) {
                                  return _vm.slideTo(category)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(category.details[0].name) +
                                  "\n                            "
                              ),
                              _c(
                                "svg",
                                {
                                  staticClass: "icon icon-chevron-right",
                                  attrs: {
                                    width: "32",
                                    height: "32",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#chevron-right" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "a",
                            {
                              staticClass: "mobile-navigation__link",
                              attrs: { href: _vm.getCategoryUrl(category.url) },
                            },
                            [_vm._v(_vm._s(category.details[0].name))]
                          ),
                        ],
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function (number) {
                      return _c(
                        "li",
                        { staticClass: "mobile-navigation__item" },
                        [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ]
                      )
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(
                    _vm.dataContainer2.parent.childCount,
                    function (number) {
                      return _c(
                        "li",
                        { staticClass: "mobile-navigation__item" },
                        [
                          _c("span", {
                            staticClass: "nav-placeholder m-3",
                            style: { width: Math.random() * 20 + 60 + "%" },
                          }),
                        ]
                      )
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized ? [_c("loading-animation")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "mobile-navigation__item" }, [
      _c(
        "a",
        {
          staticClass: "mobile-navigation__link mobile-navigation__link-red",
          attrs: { href: "/sale_t1" },
        },
        [_vm._v("SALE")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }